import { render, staticRenderFns } from "./bankSelector.vue?vue&type=template&id=578435d0"
import script from "./bankSelector.vue?vue&type=script&lang=js"
export * from "./bankSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports